import { ActionBar, media, T3, P, WarningIcon, CheckCircleIcon, SafeHtml } from 'ia-react-core';
import styled from 'styled-components';

export const StyledIcon = styled(WarningIcon)`
  color: ${({ theme }) => theme.colors.orange2};
`;

export const StyledP = styled(P)`
  margin-bottom: 12px;
  display:block;
  font-weight: 800;
 `;

export const StyledHtml = styled(SafeHtml)`
 font-size: 14px;
 line-height: 18px;
`;

export const StyledDiv = styled.div`
  text-align: center;
 `;

export const StyledHR = styled.div`
  background-color: ${({ theme }) => theme.colors.gray3};
  margin-top:36px;
  margin-bottom:36px;
  height: 1px;
`;

export const StyledWarningIcon = styled(WarningIcon)`
  color: ${({ theme }) => theme.colors.orange2};
  height: 60px;
  width: 60px;
  text-align: center;
 `;

export const StyledCheckCircleIcon = styled(CheckCircleIcon)`
  color: ${({ theme }) => theme.colors.green10};
  height: 60px;
  width: 60px;
  text-align: center;
 `;

export const StyledActionBar = styled(ActionBar)`
  align-items: center;
 `;

export const StyledT3 = styled(T3)`
  margin-bottom: 16px;
  font-size: 22px;
  margin-left:0px;
  margin-right:0px;
  ${media.sm`
      margin-left:32px;
      margin-right:32px;
  `};
`;
